import { useKindeAuth } from "@kinde-oss/kinde-auth-react";
import { useConfig } from "../../utils/useConfig";
import { getSafeSessionConfig } from "../utils/getSafeSessionConfig";
import { useMutation } from "react-query";
import { toast } from "react-toastify";
import { sendMessage } from "../../mutations/communications/sendMessage";
import { useData } from "../../utils/useData";
import { CommunicationSubject } from "../../models/communications/communicationSubject";
import { CommunicationPlatform } from "../../models/communications/communicationPlatform";

export const useSendMessage = () => {

    const { config } = useConfig();
    const { getToken } = useKindeAuth();
    const { employerId, employees } = useData();


    return useMutation(
        async ({ 
            employeeIds,
            subject,
            platform,
            templateId,
            employerName,
            message 
        }: 
        { 
            employeeIds: string[], 
            subject: CommunicationSubject, 
            platform: CommunicationPlatform, 
            templateId: string, 
            employerName: string, 
            message: string 
        }) => {
            const { API_URL, token } = await getSafeSessionConfig(config, getToken);
            return sendMessage(
                API_URL, 
                token,
                employerId, 
                employeeIds,
                subject,
                platform,
                templateId,
                employerName, 
                message
            );
        },
        {
            onSuccess: () => {
                employees.refetch();
                toast.success("Message sent successfully");
          
            },
            onError: (error: Error) => {
                console.error(error.message);
                toast.error("There was a problem sending the message");
            }
        }
    )
}